import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import api from "../api/index";
const axios = require("axios");

const initialState = {
  loading: false,
  error: false,
  data: [],
};

const tipologiesSlice = createSlice({
  name: "tipologies",
  initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getAllProjectsTipologies.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllProjectsTipologies.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllProjectsTipologies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(getAllProductsTipologies.pending, (state) => {
        state.loading = true;
      })
      .addCase(getAllProductsTipologies.fulfilled, (state, action) => {
        state.loading = false;
        state.data = action.payload;
      })
      .addCase(getAllProductsTipologies.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const getAllProjectsTipologies = createAsyncThunk(
  "tipologiesSlice/getAllProjectsTipologies",
  async () => {
    try {
      const { url, method, headers } = api.getAllProjectsTipologies();
      const referents = await axios({
        url,
        method,
        headers,
      });
      return referents.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const getAllProductsTipologies = createAsyncThunk(
  "tipologiesSlice/getAllProductsTipologies",
  async () => {
    try {
      const { url, method, headers } = api.getAllProductsTipologies();
      const referents = await axios({
        url,
        method,
        headers,
      });
      return referents.data;
    } catch (error) {
      return error.message;
    }
  }
);

export const { actions } = tipologiesSlice;
export default tipologiesSlice.reducer;
